export default __webpack_public_path__ + "static/media/text.c02f8e52.png";